module.exports = __webpack_public_path__ + "static/media/JH_web_6.a5d6f99f.jpg";